import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=deba1122&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=deba1122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deba1122",
  null
  
)

export default component.exports